import React, { useState, useEffect, useMemo } from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import equal from 'fast-deep-equal';
import CardGroup from '../CardGroup/CardGroup';
import ChangeLog from '../ChangeLog/ChangeLog';
import Loading from '../Loading/Loading';
import { fetchFilesList } from '../../api/services';
import styles from './index.module.less';

function groupItems(items) {
  return items.reduce((result, item, index) => {
    const groupIndex = Math.floor(index / 4);
    if (!result[groupIndex]) {
      result[groupIndex] = [];
    }
    result[groupIndex].push(item);
    return result;
  }, []);
}

function FilesTile({ title, params, change_logs = [] }) {
  const [filesList, setFilesList] = useState([]);
  const [showLoading, setShowLoading] = useState(true);
  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 8,
  });
  const [showBtn, setShowBtn] = useState(true);
  const parameters = useMemo(() => {
    return {
      ...params,
      pageSize: pagination.pageSize,
      pageNumber: pagination.pageNumber,
    };
  }, [pagination, params]);
  useEffect(() => {
    fetchFilesList(parameters).then(data => {
      if (data.result.length === 0) {
        setShowBtn(false);
      }
      setFilesList(prevData => {
        if (!equal(prevData, data.result)) {
          return [...prevData, ...data.result];
        }
        return prevData;
      });
      setShowLoading(false);
    });
  }, [parameters]);
  const groupedFilesList = groupItems(filesList);
  const groupedChangelogsList = groupItems(change_logs);
  const handleMoreClick = () => {
    setPagination(prevPagination => ({
      ...prevPagination,
      pageNumber: prevPagination.pageNumber + 1,
    }));
  };
  return (
    <>
      {groupedFilesList.length > 0 ? (
        <div className={styles.flies_group}>
          <div className={styles.group_header}>{title}</div>
          {change_logs.length > 0 && title === 'Firmware' ? (
            <div
              className={styles.files_rows}
              style={{ marginBottom: 20 }}
            >
              {
                // 遍历每个组
                groupedChangelogsList.map((changelogs, index) => {
                  return (
                    <ChangeLog
                      key={index}
                      changelogs={changelogs}
                    />
                  );
                })
              }
            </div>
          ) : null}
          <div className={styles.files_rows}>
            {
              // 遍历每个组
              groupedFilesList.map((files, index) => {
                return (
                  <CardGroup
                    key={index}
                    files={files}
                    title={title}
                  />
                );
              })
            }
            {
              // 如果有更多数据
              filesList.length >= 8 && showBtn && (
                <Button
                  type='dash'
                  size={'large'}
                  block
                  onClick={handleMoreClick}
                  style={{
                    border: '1px solid #d9d9d9',
                    width: 120,
                    height: 40,
                    margin: '0 auto',
                  }}
                >
                  More
                  <DownOutlined />
                </Button>
              )
            }
          </div>
        </div>
      ) : (
        showLoading && <Loading />
      )}
    </>
  );
}

export default React.memo(FilesTile, equal);
